"use client";
import { SimpleHero } from "trimble-terra"
// import { SimpleHero } from "trimble-terra/SimpleHero" 

export const NotAuthorized = () => {

  const notFoundHeroData = {
    header: "403 - Not Authorized",
    backgroundImage: {
      title: "403 background image",
      url: "//images.ctfassets.net/citn2sn5tdjr/7lTco8jlp0hd6AY0KliaG7/1b98ceac49e765c2d904265109a5421a/Hero_homepage.jpg",
      x: 0,
      y: 0,
    },

    description: "<p>Not Authorized</p>",
    isHeaderBig: true,
    buttons:  [
      {
        label: "Return Home",
        destination: "/en-US/homepage",
        primary: true,
      }
    ],
    isWrapped: true
  };

  return (
    <div className="not-authorized-page">
      <SimpleHero {...notFoundHeroData} />
    </div>
  )
}

export default NotAuthorized;